import DebitCardInfo from './DebitCardInfo';

export default DebitCardInfo;
